import React from 'react'
import './Usage.scss'

function Usage() {
  return (
    <div className='dashContainer'>
        <div className='containerHeader'>
            <h1>Data Usage</h1>
        </div>

        <div className='usageGrid'>
          <div>
            <h2 className='usageAmount'>8 GB</h2>
            <h3 className='usageSubtitle'>Used Today</h3>
          </div>
          <div>
            <h2 className='usageAmount'>8/12 GB</h2>
            <h3 className='usageSubtitle'>Remaining Data</h3>
          </div>
        </div>

        <div className='dataUsed'>
          <h3 className='subText'>GB Remaining</h3>
          <div className='amountBar2' />
          <button className='btn generateButton' style={{width: '100%'}}>Purchase Data</button>
        </div>
    </div>
  )
}

export default Usage